import { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IosShareIcon from "@mui/icons-material/IosShare";
import { QRCodeSVG } from "qrcode.react";
import { TestLink } from "../api/testLinks";
import { formatLocalDateTime } from "../utils/datetime";

// Готовая одноразовая ссылка: копирование, системный Share (iPad), QR
export function ShareLinkDialog({ link, onClose }: { link: TestLink | null; onClose: () => void }) {
  const [copied, setCopied] = useState(false);
  if (!link) return null;
  const canShare = typeof navigator !== "undefined" && !!navigator.share;

  const copy = async () => {
    await navigator.clipboard.writeText(link.url);
    setCopied(true);
  };
  const share = () => navigator.share({ title: "Cognitive test", url: link.url }).catch(() => {});

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Test link</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          One-time link. Valid until {formatLocalDateTime(link.expires_at)}.
        </Typography>
        <TextField fullWidth size="small" value={link.url} slotProps={{ htmlInput: { readOnly: true } }} />
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ mt: 1.5 }}>
          <Button fullWidth variant="outlined" startIcon={<ContentCopyIcon />} onClick={copy}>
            {copied ? "Copied" : "Copy"}
          </Button>
          {canShare && (
            <Button fullWidth variant="outlined" startIcon={<IosShareIcon />} onClick={share}>Share</Button>
          )}
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <QRCodeSVG value={link.url} size={192} />
        </Box>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
  );
}
